// src/hooks/useSessionState.js
import { useEffect, useState } from 'react';

/**
 * `useState` que sobrevive à navegação dentro da aba (sessionStorage): filtros e
 * página de uma listagem continuam iguais ao voltar de um detalhe.
 *
 * As chaves precisam estar em utils/clearAppSessionState.js (prefixo ou exata), para
 * o logout limpá-las e o estado não passar de um usuário para outro na mesma aba.
 *
 * @param hydrator  converte o valor lido (JSON) de volta, ex.: datas em dayjs.
 */
export default function useSessionState(key, initialValue, hydrator = null) {
    const [state, setState] = useState(() => {
        try {
            const storedValue = sessionStorage.getItem(key);
            if (storedValue !== null) {
                const parsed = JSON.parse(storedValue);
                try {
                    return hydrator ? hydrator(parsed) : parsed;
                } catch (err) {
                    console.error(
                        `Hydration failed for key "${key}". Reverting to initialValue.`,
                        err
                    );
                    return initialValue;
                }
            }
            return initialValue;
        } catch (error) {
            console.error(`Error parsing session storage key "${key}":`, error);
            return initialValue;
        }
    });

    useEffect(() => {
        if (state instanceof Set) {
            sessionStorage.setItem(key, JSON.stringify(Array.from(state)));
        } else {
            sessionStorage.setItem(key, JSON.stringify(state));
        }
    }, [key, state]);

    return [state, setState];
}
